import { fetchLocalToursByCityCode, fetchGAdvData } from './services'

const getDefaultState = () => {
  return {
    localTours: null
  }
}

const state = getDefaultState()

const getters = {
  getLocalTours: (state) => {
    return state.localTours ? state.localTours : null
  }
}

const actions = {
  async loadAllLocalTours  ({ commit, rootState }) {
    const booking = rootState.booking.booking

    if (!booking || !booking.booking_information || !Array.isArray(booking.booking_information.citylink)) {
      return null
    }

    const localTours = {}

    for (let i = 0; i < booking.booking_information.citylink.length; i++) {
      const code = booking.booking_information.citylink[i]
      const res = await fetchLocalToursByCityCode(code)
      if (res && res.tours && res.tours.items && res.tours.items[0]) {
        localTours[code] = res
      }
    }

    commit('localToursReceived', localTours)
  },

  resetStateAction ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  localToursReceived (state, localTours) {
    state.localTours = localTours
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
